export default __webpack_public_path__ + "static/0168-1116580faff4ce5fa3bf3fc6db0b0947.png";